var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49.6 49.6",
    style: {
      enableBackground: "new 0 0 49.6 49.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,0H9.6C4.3,0,0,4.3,0,9.6v10.1V40c0,5.3,4.3,9.6,9.6,9.6H40c5.3,0,9.6-4.3,9.6-9.6V19.7V9.6 C49.6,4.3,45.3,0,40,0z M42.7,5.7l1.1,0v1.1v7.3l-8.4,0l0-8.4L42.7,5.7z M17.7,19.7c1.6-2.2,4.2-3.6,7.1-3.6c2.9,0,5.5,1.4,7.1,3.6 c1,1.4,1.7,3.2,1.7,5.1c0,4.8-3.9,8.7-8.7,8.7c-4.8,0-8.7-3.9-8.7-8.7C16.1,22.9,16.7,21.1,17.7,19.7z M44.7,40 c0,2.6-2.1,4.8-4.8,4.8H9.6c-2.6,0-4.8-2.1-4.8-4.8V19.7h7.4c-0.6,1.6-1,3.3-1,5.1c0,7.5,6.1,13.6,13.6,13.6 c7.5,0,13.6-6.1,13.6-13.6c0-1.8-0.4-3.5-1-5.1h7.4V40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.37b98e6ff9393c17e9242e83134dd362.svg";
export { ForwardRef as ReactComponent };